var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "m-2" },
    [
      _c("div", { staticClass: "d-flex flex-row align-items-center mb-2" }, [
        _c("div", { staticClass: "ml-auto" }),
        _vm._v(" "),
        _vm.canEditInherited
          ? _c("div", { staticClass: "custom-control custom-switch" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.editInherited,
                    expression: "editInherited"
                  }
                ],
                staticClass: "custom-control-input",
                attrs: { type: "checkbox", id: _vm._uid + "switch" },
                domProps: {
                  checked: Array.isArray(_vm.editInherited)
                    ? _vm._i(_vm.editInherited, null) > -1
                    : _vm.editInherited
                },
                on: {
                  change: function($event) {
                    var $$a = _vm.editInherited,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 && (_vm.editInherited = $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          (_vm.editInherited = $$a
                            .slice(0, $$i)
                            .concat($$a.slice($$i + 1)))
                      }
                    } else {
                      _vm.editInherited = $$c
                    }
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "label",
                {
                  staticClass: "custom-control-label",
                  attrs: { for: _vm._uid + "switch" }
                },
                [_vm._v("Edit inherited")]
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "btn-group ml-2" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-secondary",
              on: {
                click: function($event) {
                  return _vm.store.reload(true)
                }
              }
            },
            [_c("i", { staticClass: "fa fa-sync" })]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-success",
              on: { click: _vm.newDefinition }
            },
            [_c("i", { staticClass: "fa fa-plus" })]
          )
        ])
      ]),
      _vm._v(" "),
      _c("VueGoodTable", {
        attrs: {
          columns: _vm.columnsConfig,
          rows: _vm.rows,
          "pagination-options": _vm.paginationOptions,
          "search-options": _vm.searchOptions
        },
        scopedSlots: _vm._u([
          {
            key: "emptystate",
            fn: function() {
              return [
                _c("CenterOnParent", [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("txtSearchNoRows")) +
                      "\n      "
                  )
                ])
              ]
            },
            proxy: true
          },
          {
            key: "table-row",
            fn: function(props) {
              return [
                props.column.field === "actions"
                  ? _c("div", { staticClass: "btn-group" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-sm btn-primary",
                          on: {
                            click: function($event) {
                              return _vm.editDefinition(props.row)
                            }
                          }
                        },
                        [_c("i", { staticClass: "fa fa-pen" })]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                props.column.isLocaleColumn
                  ? _c("div", [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.formatTranslationsCell(
                              props.column.field(props.row),
                              _vm.editInherited
                            )
                          ) +
                          "\n      "
                      )
                    ])
                  : _c("span", [
                      _vm._v(
                        "\n        " +
                          _vm._s(props.formattedRow[props.column.field]) +
                          "\n      "
                      )
                    ])
              ]
            }
          }
        ])
      }),
      _vm._v(" "),
      _c("TranslationEditModal", {
        ref: "editModal",
        attrs: { editInherited: _vm.editInherited }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }